<div>
    <p class="mb-2 fw-bold">Drag and Drop Or Select File(s)</p>
    <div class="drop-zone border border-primary rounded p-4 d-flex flex-wrap align-items-center justify-content-center"
        appDragDrop (filesDropped)="onFilesDropped($event)" (draggedOver)="onDragOver($event)"
        (click)="fileInput.click()" tabindex="0"
        aria-label="Drag images here or click to select" style="min-height: 160px; background: #f7f7fc;">

        @if (!(images().length)) {
        <p class="text-muted">Drop Zone <u>click to select</u></p>
        }
        @for (img of images(); let i = $index; track i) {
        <div class="preview me-3 mb-2 text-center">
            <img [src]="img.previewUrl" width="100" class="img-thumbnail mb-1" />
            <div class="d-flex flex-column align-items-center">
                <small class="text-break">{{ img.file.name }}</small>
                <button type="button" class="btn btn-sm btn-outline-danger mt-1"
                    (click)="removeImage(i); $event.stopPropagation();">
                    Remove
                </button>
            </div>
        </div>
        }
    </div>
    <input #fileInput type="file" multiple accept="image/*" hidden (change)="onFilesSelected($event)" />
    <div class="mt-3">
        <span class="me-2 fw-medium">{{images().length}} image(s) selected.</span>
        <button class="btn btn-primary" (click)="uploadImages()" [disabled]="uploading() || !images().length">
            Upload
        </button>
        @if (uploading()) {
        <span class="ms-2 text-info">Uploading... {{uploadProgress()}}%</span>
        }
        @if (error()) {
        <span class="ms-2 text-danger">{{error()}}</span>
        }
    </div>
</div>